module.exports = __webpack_public_path__ + "img/close.21ff5b8f.png";